// Import Actions
import { SET_ERROR, SET_SUCCESS, CLEAN } from './ErrorsActions';

// Initial State
const initialState = {
  error: '',
  success: '',
  opt: {}
};

const ErrorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return {
        error: action.error,
        opt: action.opt
      };
    case SET_SUCCESS:
      return {
        success: action.msg,
        opt: action.opt
      };
    case CLEAN: {
      return initialState;
    }

    default:
      return state;
  }
};

// Export Reducer
export default ErrorsReducer;
